import { PT_ORDERS, PT_VIEWINVOICE } from "./paths/pt-orders";
import { RTOrder, RTViewInvoice } from "../screens/sc-orders";
import { KEY_GENERATOR } from "../../functions/funtion";
import { Route } from "react-router-dom";

let RouteArray = [
  [
    <Route key={KEY_GENERATOR()} path={PT_ORDERS} element={<RTOrder />} />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_VIEWINVOICE}
      element={<RTViewInvoice />}
    />,    
  ],
];

export default RouteArray;
